import React from 'react';
import Login from '../domains/auth/components/Login';

const LoginPage: React.FC = () => {
  return <Login />;
};

export default LoginPage; 